module.exports = __webpack_public_path__ + "img/nav-design-modern.769d6f4.jpg";